
import React from 'react';
import { motion } from 'framer-motion';
import { ClassYearImage } from '@/components/registration';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useIsMobile } from '@/hooks/use-mobile';

interface ClassYearImageSectionProps {
  selectedClassYear: string | null;
}

const ClassYearImageSection: React.FC<ClassYearImageSectionProps> = ({ selectedClassYear }) => {
  const isMobile = useIsMobile();
  
  // Modified to show on both mobile and desktop with different styling
  return (
    <motion.div 
      className={`w-full ${isMobile ? 'mt-2' : 'h-full'}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      {selectedClassYear ? (
        <div className={`${isMobile ? 'h-44' : 'h-full'} rounded-xl overflow-hidden shadow-md border-2 border-[#D3E4FD]`}>
          <ClassYearImage selectedClassYear={selectedClassYear} />
        </div>
      ) : (
        <div className={`${isMobile ? 'h-24' : 'h-full'} flex items-center justify-center bg-gradient-to-r from-blue-50 to-sky-50 rounded-xl p-4 border-2 border-[#D3E4FD] shadow-sm`}>
          <p className="text-blue-700 text-center text-sm md:text-lg">
            Chọn lớp để xem ảnh kỷ yếu
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default ClassYearImageSection;
